import { NavController, NavParams, ModalController, Content } from 'ionic-angular';
import { Component, ViewChild } from '@angular/core';
import { ToastController, AlertController } from 'ionic-angular';
import { Headers, RequestOptions } from '@angular/http';
import { CartManager } from "../../providers/cart-manager";
import { Api } from '../../providers/api';
import { IMAGES_BASE_URL, Constants, ApplicationVariables } from '../../providers/config';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage';
import { Printer, PrintOptions, Push } from 'ionic-native';
import { MsgManager } from '../../providers/msg-manager';
import { GVLogger } from '../../services/gv-logger';
import { ConfirmShipmentPage } from "../confirm-shipment/confirm-shipment";
import { ShipmentcartManagerProvider } from "../../providers/shipmentcart-manager";
import { MyOrderPage } from "../my-order/my-order";
import { BULKSHIPMENTCART, pickPackParams } from "../../providers/data";
import { BulkshipmentcartManager } from "../../providers/bulkshipmentcart-manager";
import { PickPackParamsPage } from "../pickpackparams/pickpackparams";
import { stringify } from "@angular/core/src/util";


@Component({
  selector: 'page-bulk-shipments',
  templateUrl: 'bulk-shipment.html',
})
export class BulkShipmentPage {

  order: any;
  shipmentsData
  private shipmentsAvailabilityCheck: boolean = false;
  private shipmentsLength = 0;
  productLocationDisplayStatus: boolean = true;
  // enteredShipmentNo = ""
  downloadCSVButtonStatus = true;
  pickPackParamsVariables: any;
  deoded: string;
  private paramsFromServer: any;
  constants = Constants;
  ordersList = [];
  private getParamsFieldsFromServerside = false;
  public barCodeFocus = "Scan Order ID or ERP/Scan Code here";
  isUpdatingShipments: boolean = false;
  isSearchingShipments: boolean = false;
  @ViewChild('barcodeFocus') barCodeFocusInput;
  @ViewChild(Content) content: Content;

  constructor(public nav: NavController,
    private bulkShipmentCartManager: BulkshipmentcartManager,
    private cartManager: CartManager,
    private api: Api, public storage: Storage,
    public toastCtrl: ToastController,
    public params: NavParams,
    public alertCtrl: AlertController,
    public msgManager: MsgManager,
    private gVLogger: GVLogger,
    private modalCtrl: ModalController,
    // private shipmentCartManager:ShipmentcartManagerProvider
  ) {


    // alert("kk")
    this.shipmentsData = BULKSHIPMENTCART;
    this.order = this.params.get("orderView");
    // this.shipments();
    this.getParamsFieldsFromServer();
  }


  shipments() {
    this.gVLogger.log("shipments calledddddddd : ");
    var url = "/order/loadShipmentsByOrder";
    var body = "?searchString=" + this.order.id;
    var shipmentAvail = false;
    this.api.post(url + body, null).map(res => res.json()).subscribe(data => {
      this.gVLogger.log("data from /products/getProductsForPickShip : " + data);
      if (data.status === "200") {

        for (let index of data.data) {
          this.gVLogger.log("index for loop in shipments + " + JSON.stringify(index.shipmentNoticeByNoticesId.shipmentNo))
          if (this.shipmentsData.shipments.length > 0) {
            shipmentAvail = false;
            for (let shipments of this.shipmentsData.shipments) {
              this.gVLogger.log("shipments for loop in shipments + " + JSON.stringify(shipments.shipmentNoticeByNoticesId.shipmentNo))

              if (shipments.shipmentNoticeByNoticesId.shipmentNo === index.shipmentNoticeByNoticesId.shipmentNo) {
                shipmentAvail = true;
              }
            }
          }
          this.gVLogger.log("shipment avail status : " + shipmentAvail);
          if (!shipmentAvail) {
            this.shipmentsData.shipments.push(index);
          }
        }
        // this.shipmentsData = data.data;
        this.shipmentsLength = this.shipmentsData.shipments.length;
        this.gVLogger.log("shipment length in pick pack list page : " + this.shipmentsLength);
        if (data.data.length > 0) {

          this.shipmentsAvailabilityCheck = false;
        }
        else {
          this.shipmentsAvailabilityCheck = true;
        }
      }
      else {
        this.shipmentsData.shipments = [];
        this.shipmentsAvailabilityCheck = true;
      }
    });
  }

  findShipmentsByOrderId(event) {
    event.target.value = event.target.value.trim();
    let enteredShipmentNo = event.target.value;
    if (enteredShipmentNo !== undefined && enteredShipmentNo.trim() !== "") {
      this.isSearchingShipments = true;
      var url = "/order/loadShipmentsByOrder";
      var body = "?searchString=" + enteredShipmentNo;
      var shipmentAvail = false;
      this.api.post(url + body, null).map(res => res.json()).subscribe(data => {
        this.gVLogger.log("data from /products/getProductsForPickShip : " + data);
        if (data.status === "200") {
          for (let index of data.data) {
            this.gVLogger.log("index for loop in shipmentssssss + " + JSON.stringify(this.shipmentsData.shipments))
            if (this.shipmentsData.shipments.length > 0) {
              shipmentAvail = false;
              for (let shipments of this.shipmentsData.shipments) {
                this.gVLogger.log("shipments for loop in shipments + " + JSON.stringify(shipments.shipmentNoticeByNoticesId.shipmentNo))

                if (shipments.shipmentNoticeByNoticesId.referenceNo === index.shipmentNoticeByNoticesId.referenceNo) {
                  shipmentAvail = true;
                }
              }
            }
            this.gVLogger.log("shipment avail status : " + shipmentAvail);
            if (!shipmentAvail) {

              // this.shipmentsData.push(index);
              if (index.shipmentNoticeByNoticesId.status === 5) {
                this.bulkShipmentCartManager.addToCartNew(index);
                this.scrollBottom();
                this.getOrderAgainstShipment(index);
                setTimeout(() => {
                  this.scrollBottom();
                  event.target.value = "";
                  event.target.focus();
                }, 1000)
              } else {
                this.api.toastMSG("No shipment found against search.")
                setTimeout(() => {
                  this.scrollBottom();
                  event.target.value = "";
                  event.target.focus();
                }, 1000)
              }
            } else {
              setTimeout(() => {
                this.scrollBottom();
                event.target.value = "";
                event.target.focus();
              }, 1000)
            }
          }
          // this.shipmentsData = data.data;
          this.shipmentsLength = this.shipmentsData.shipments.length;
          this.gVLogger.log("shipment length in pick pack list page : " + this.shipmentsLength);
          if (data.data.length > 0) {
            this.shipmentsAvailabilityCheck = false;
            setTimeout(() => {
              this.scrollBottom();
              event.target.value = "";
              event.target.focus();
            }, 1000)
          } else {
            this.api.toastMSG("No ship ready shipments found against order#.")
            this.shipmentsAvailabilityCheck = true;
            setTimeout(() => {
              this.scrollBottom();
              event.target.value = "";
              event.target.focus();
            }, 1000)
          }
        } else {
          this.api.toastMSG("No ship ready shipments found against order#.")
          this.shipmentsData.shipments = [];
          this.shipmentsAvailabilityCheck = true;
          this.scrollBottom();
          event.target.value = "";
          event.target.focus();
        }
        this.isSearchingShipments = false;
      }, error => {
        this.isSearchingShipments = false;
        this.api.toastMSG("Error occurred while fetching shipments.");
        event.target.value = "";
        event.target.focus();
      });
    }

    this.scrollBottom();
    event.target.value = "";
    event.target.focus();

    console.log("ORDER LIST : " + JSON.stringify(this.ordersList))
  }

  deleteShipment(shipment) {
    this.bulkShipmentCartManager.deleteProductFromCart(shipment);
    // var index= this.shipmentsData.map(function(x) {return x.shipmentNoticeByNoticesId.referenceNo; }).indexOf(shipment.shipmentNoticeByNoticesId.referenceNo);
    // alert(index)
    // this.shipmentsData.splice(index,1);
    // this.shipmentsData = BULKSHIPMENTCART;

    // var index= BULKSHIPMENTCART.shipments.map(function(x) {return x.shipmentNoticeByNoticesId.referenceNo; }).indexOf(product.shipmentNoticeByNoticesId.referenceNo);
    // if (index != -1) {
    //   this.removeNew(index);
    // }

  }

  getOrderAgainstShipment(shipment) {
    console.log("Shipmett : " + JSON.stringify(shipment))
    // if(this.productLocationDisplayStatus){
    //   this.productLocationDisplayStatus = false;

    // var index= this.ordersList.map(function(x) {return x.id; }).indexOf(shipment.shipmentNoticeByNoticesId.poNo);
    // if(index !== -1){
    //   // this.api.post("order/loadByOrderId?orderId=" + shipment.shipmentNoticeByNoticesId.poNo,null).map(res => res.json()).subscribe(OrderData => {
    //   //   this.gVLogger.log("data from /products/getProductsForPickShip : " + OrderData);
    //   //   if(OrderData.status === "200") {
    //   //     this.gVLogger.log("tap called...");
    //       var url = "/order/loadShipment";
    //       var body = "?orderId="+this.enteredShipmentNo+"&shipmentId="+shipment.shipmentNoticeByNoticesId.id;
    //       this.api.post(url+body,null).map(res => res.json()).subscribe(data => {
    //         if(data.status === "200") {
    //           // let orderPickPackList = OrderData.data;
    //           // let orderView = orderPickPackList;
    //
    //
    //           // let productsList: any = [];
    //           // let productsListForShipment: any = [];
    //           for(let orderDetail of data.data.orderDetailShipmentDTOS){
    //             // let product: any = orderDetail.productsDTO;
    //             this.ordersList.map(function(x) {return x.id; }).indexOf(shipment.shipmentNoticeByNoticesId.poNo);
    //             this.ordersList[index].orderDetailDTOs.push(orderDetail);
    //           }
    //           // let cart:any = {};
    //
    //           // this.gVLogger.log(orderPickPackList);
    //
    //           // cart.customer = orderPickPackList.customerDTO;
    //           // cart.orderMessage = orderPickPackList.orderMessage;
    //           // cart.expectedShipmentDate = orderPickPackList.expectedShipmentDate;
    //           // cart.shippingServiceName = orderPickPackList.shippingServiceName;
    //           // cart.shippingServiceId = orderPickPackList.shippingServiceValue;
    //           // cart.orderId = orderPickPackList.id;
    //           // cart.shipmentId = shipment.shipmentNoticeByNoticesId.id;
    //           // cart.shipmentNoticeStatus = shipment.shipmentNoticeByNoticesId.status;
    //           // cart.items = productsList;
    //           // // cart.items = this.shipmentCartManager.getItems();
    //           // cart.orderStatus = orderPickPackList.orderStatus;
    //           // cart.orderTitle = orderPickPackList.orderTitle;
    //           //
    //           // this.nav.push(ConfirmShipmentPage,{"cart":cart,"TotalPrice":orderPickPackList.totalAmount, "orderView" : orderView, "pageStatus" : "shipment", "plannedShipmentDate" : data.data.plannedShipmentDate, "shipmentNo" : shipment.shipmentNoticeByNoticesId.shipmentNo, "shipmentId" : shipment.shipmentNoticeByNoticesId.id});
    //         }
    //         else {
    //           this.gVLogger.log("else calledd with shipmentDetails ");
    //         }
    //       });
    //       setTimeout(() => {
    //         this.productLocationDisplayStatus = true;
    //       },1000)
    //     // }
    //     // else {
    //     //   this.api.toastMSG("Some thing went wrong.");
    //     //   this.productLocationDisplayStatus = true;
    //     // }
    //   // });
    // }else {
    this.api.post("order/loadByOrderId?orderId=" + shipment.shipmentNoticeByNoticesId.poNo, null).map(res => res.json()).subscribe(OrderData => {
      this.gVLogger.log("data from /products/getProductsForPickShip : " + OrderData);
      if (OrderData.status === "200") {
        this.gVLogger.log("tap called...");
        var url = "/order/loadShipment";
        var body = "?orderId=" + shipment.shipmentNoticeByNoticesId.poNo + "&shipmentId=" + shipment.shipmentNoticeByNoticesId.id;
        this.api.post(url + body, null).map(res => res.json()).subscribe(data => {
          if (data.status === "200") {

            let orderPickPackList = OrderData.data;
            let orderView = orderPickPackList;

            orderView.orderDetailDTOs = data.data.orderDetailShipmentDTOS;

            // shipment.order = orderView

            this.bulkShipmentCartManager.addOrderAgainstShipment(orderView, shipment);



            // return shipment;
            // this.ordersList.push(orderView);


            // let productsList: any = [];
            // let productsListForShipment: any = [];
            // for(let orderDetail of data.data.orderDetailShipmentDTOS){
            //   let product: any = orderDetail.productsDTO;
            //   productsList.push(product);
            // }
            // let cart:any = {};

            // this.gVLogger.log(orderPickPackList);

            // cart.customer = orderPickPackList.customerDTO;
            // cart.orderMessage = orderPickPackList.orderMessage;
            // cart.expectedShipmentDate = orderPickPackList.expectedShipmentDate;
            // cart.shippingServiceName = orderPickPackList.shippingServiceName;
            // cart.shippingServiceId = orderPickPackList.shippingServiceValue;
            // cart.orderId = orderPickPackList.id;
            // cart.shipmentId = shipment.shipmentNoticeByNoticesId.id;
            // cart.shipmentNoticeStatus = shipment.shipmentNoticeByNoticesId.status;
            // cart.items = productsList;
            // // cart.items = this.shipmentCartManager.getItems();
            // cart.orderStatus = orderPickPackList.orderStatus;
            // cart.orderTitle = orderPickPackList.orderTitle;

            // this.nav.push(ConfirmShipmentPage,{"cart":cart,"TotalPrice":orderPickPackList.totalAmount, "orderView" : orderView, "pageStatus" : "shipment", "plannedShipmentDate" : data.data.plannedShipmentDate, "shipmentNo" : shipment.shipmentNoticeByNoticesId.shipmentNo, "shipmentId" : shipment.shipmentNoticeByNoticesId.id});
          }
          else {
            this.gVLogger.log("else calledd with shipmentDetails ");
          }
        });
        setTimeout(() => {
          this.productLocationDisplayStatus = true;
        }, 1000)
      }
      else {
        this.api.toastMSG("Some thing went wrong.");
        this.productLocationDisplayStatus = true;
      }
    });
    // }






    // }






    // if(this.productLocationDisplayStatus){
    //   this.productLocationDisplayStatus = false;
    //
    //   this.gVLogger.log("tap called...");
    //   var url = "/order/loadShipment";
    //   var body = "?orderId="+this.enteredShipmentNo+"&shipmentId="+shipment.shipmentNoticeByNoticesId.id;
    //   this.api.post(url+body,null).map(res => res.json()).subscribe(data => {
    //     if(data.status === "200") {
    //       let orderPickPackList = this.order;
    //       let orderView = orderPickPackList;
    //
    //
    //       let productsList: any = [];
    //       let productsListForShipment: any = [];
    //       for(let orderDetail of data.data.orderDetailShipmentDTOS){
    //         let product: any = orderDetail.productsDTO;
    //         productsList.push(product);
    //       }
    //       let cart:any = {};
    //
    //       this.gVLogger.log(orderPickPackList);
    //
    //       cart.customer = orderPickPackList.customerDTO;
    //       cart.orderMessage = orderPickPackList.orderMessage;
    //       cart.expectedShipmentDate = orderPickPackList.expectedShipmentDate;
    //       cart.shippingServiceName = orderPickPackList.shippingServiceName;
    //       cart.shippingServiceId = orderPickPackList.shippingServiceValue;
    //       cart.orderId = orderPickPackList.id;
    //       cart.shipmentId = shipment.shipmentNoticeByNoticesId.id;
    //       cart.shipmentNoticeStatus = shipment.shipmentNoticeByNoticesId.status;
    //       cart.items = productsList;
    //       // cart.items = this.shipmentCartManager.getItems();
    //       cart.orderStatus = orderPickPackList.orderStatus;
    //       cart.orderTitle = orderPickPackList.orderTitle;
    //
    //       this.nav.push(ConfirmShipmentPage,{"cart":cart,"TotalPrice":orderPickPackList.totalAmount, "orderView" : orderView, "pageStatus" : "shipment", "plannedShipmentDate" : data.data.plannedShipmentDate, "shipmentNo" : shipment.shipmentNoticeByNoticesId.shipmentNo, "shipmentId" : shipment.shipmentNoticeByNoticesId.id});
    //     }
    //     else {
    //       this.gVLogger.log("else calledd with shipmentDetails ");
    //     }
    //   });
    //   setTimeout(() => {
    //     this.productLocationDisplayStatus = true;
    //   },1000)
    // }
  }

  shipmentDetails(shipment) {



    if (this.productLocationDisplayStatus) {
      this.productLocationDisplayStatus = false;


      this.api.post("order/loadByOrderId?orderId=" + shipment.shipmentNoticeByNoticesId.poNo, null).map(res => res.json()).subscribe(OrderData => {
        this.gVLogger.log("data from /products/getProductsForPickShip : " + OrderData);
        if (OrderData.status === "200") {
          this.gVLogger.log("tap called...");
          var url = "/order/loadShipment";
          var body = "?orderId=" + shipment.shipmentNoticeByNoticesId.poNo + "&shipmentId=" + shipment.shipmentNoticeByNoticesId.id;
          this.api.post(url + body, null).map(res => res.json()).subscribe(data => {
            if (data.status === "200") {
              let orderPickPackList = OrderData.data;
              let orderView = orderPickPackList;


              let productsList: any = [];
              let productsListForShipment: any = [];
              for (let orderDetail of data.data.orderDetailShipmentDTOS) {
                let product: any = orderDetail.productsDTO;
                productsList.push(product);
              }
              let cart: any = {};

              this.gVLogger.log(orderPickPackList);

              cart.customer = orderPickPackList.customerDTO;
              cart.orderMessage = orderPickPackList.orderMessage;
              cart.expectedShipmentDate = orderPickPackList.expectedShipmentDate;
              cart.shippingServiceName = orderPickPackList.shippingServiceName;
              cart.shippingServiceId = orderPickPackList.shippingServiceValue;
              cart.orderId = orderPickPackList.id;
              cart.shipmentId = shipment.shipmentNoticeByNoticesId.id;
              cart.shipmentNoticeStatus = shipment.shipmentNoticeByNoticesId.status;
              cart.items = productsList;
              // cart.items = this.shipmentCartManager.getItems();
              cart.orderStatus = orderPickPackList.orderStatus;
              cart.orderTitle = orderPickPackList.orderTitle;

              this.nav.push(ConfirmShipmentPage, { "cart": cart, "TotalPrice": orderPickPackList.totalAmount, "orderView": orderView, "pageStatus": "shipment", "plannedShipmentDate": data.data.plannedShipmentDate, "shipmentNo": shipment.shipmentNoticeByNoticesId.shipmentNo, "shipmentId": shipment.shipmentNoticeByNoticesId.id });
            }
            else {
              this.gVLogger.log("else calledd with shipmentDetails ");
            }
          });
          setTimeout(() => {
            this.productLocationDisplayStatus = true;
          }, 1000)
        }
        else {
          this.api.toastMSG("Some thing went wrong.");
          this.productLocationDisplayStatus = true;
        }
      });




    }






    // if(this.productLocationDisplayStatus){
    //   this.productLocationDisplayStatus = false;
    //
    //   this.gVLogger.log("tap called...");
    //   var url = "/order/loadShipment";
    //   var body = "?orderId="+this.enteredShipmentNo+"&shipmentId="+shipment.shipmentNoticeByNoticesId.id;
    //   this.api.post(url+body,null).map(res => res.json()).subscribe(data => {
    //     if(data.status === "200") {
    //       let orderPickPackList = this.order;
    //       let orderView = orderPickPackList;
    //
    //
    //       let productsList: any = [];
    //       let productsListForShipment: any = [];
    //       for(let orderDetail of data.data.orderDetailShipmentDTOS){
    //         let product: any = orderDetail.productsDTO;
    //         productsList.push(product);
    //       }
    //       let cart:any = {};
    //
    //       this.gVLogger.log(orderPickPackList);
    //
    //       cart.customer = orderPickPackList.customerDTO;
    //       cart.orderMessage = orderPickPackList.orderMessage;
    //       cart.expectedShipmentDate = orderPickPackList.expectedShipmentDate;
    //       cart.shippingServiceName = orderPickPackList.shippingServiceName;
    //       cart.shippingServiceId = orderPickPackList.shippingServiceValue;
    //       cart.orderId = orderPickPackList.id;
    //       cart.shipmentId = shipment.shipmentNoticeByNoticesId.id;
    //       cart.shipmentNoticeStatus = shipment.shipmentNoticeByNoticesId.status;
    //       cart.items = productsList;
    //       // cart.items = this.shipmentCartManager.getItems();
    //       cart.orderStatus = orderPickPackList.orderStatus;
    //       cart.orderTitle = orderPickPackList.orderTitle;
    //
    //       this.nav.push(ConfirmShipmentPage,{"cart":cart,"TotalPrice":orderPickPackList.totalAmount, "orderView" : orderView, "pageStatus" : "shipment", "plannedShipmentDate" : data.data.plannedShipmentDate, "shipmentNo" : shipment.shipmentNoticeByNoticesId.shipmentNo, "shipmentId" : shipment.shipmentNoticeByNoticesId.id});
    //     }
    //     else {
    //       this.gVLogger.log("else calledd with shipmentDetails ");
    //     }
    //   });
    //   setTimeout(() => {
    //     this.productLocationDisplayStatus = true;
    //   },1000)
    // }
  }

  // ngOnDestroy(){
  //   let prodPickedStatus = 0;
  //   let itemCountForOneOfItsKind = 0;
  //   let oneOfItsKindAvailCheck = false;
  //   for(let product of this.shipmentCartManager.getItems()){
  //     if(product.productType === 1){
  //       itemCountForOneOfItsKind += 1;
  //     }
  //     for(let qtyPicked of product.productInventoryLocationsDTO){
  //       if(qtyPicked.status === 1){
  //         prodPickedStatus = 1;
  //         break;
  //       }
  //     }
  //   }
  //
  //   if(this.shipmentCartManager.getItems().length === itemCountForOneOfItsKind){
  //     oneOfItsKindAvailCheck = true;
  //   }
  //   if(this.shipmentCartManager.getItems().length > 0 && prodPickedStatus === 1 && oneOfItsKindAvailCheck === false){
  //     let confirm = this.alertCtrl.create({
  //       title: 'Unsaved cart found.',
  //       message: "What would you like to do?",
  //       buttons: [
  //         {
  //           text: 'Go to old cart',
  //           handler: () => {
  //             let orderView = this.order;
  //
  //             this.gVLogger.log("orrrdddeeeerrrr before before adding in shipment cart manager : " + JSON.stringify(this.order));
  //
  //             let productsList: any = [];
  //             for(let orderDetail of this.order.orderDetailDTOs){
  //               let product: any = orderDetail.productsDTO;
  //               productsList.push(product);
  //               this.shipmentCartManager.addProductToCart(product);
  //             }
  //
  //             for(let ship of this.shipmentCartManager.getItems()){   // UD code in server down
  //               if(ship.productType === 1){
  //                 ship.productInventoryLocationsDTO[0].quantityReceived = ship.quantity;
  //                 ship.productInventoryLocationsDTO[0].status = 1;
  //               }
  //             }
  //
  //
  //
  //             let cart:any = {};
  //
  //             this.gVLogger.log(this.order);
  //
  //             cart.customer = this.order.customerDTO;
  //             cart.orderMessage = this.order.orderMessage;
  //             cart.expectedShipmentDate = this.order.expectedShipmentDate;
  //             cart.shippingServiceName = this.order.shippingServiceName;
  //             cart.shippingServiceId = this.order.shippingServiceValue;
  //             cart.orderId = this.order.id;
  //             // cart.items = productsList;
  //             cart.items = this.shipmentCartManager.getItems();
  //             cart.orderStatus = this.order.orderStatus;
  //             cart.orderTitle = this.order.orderTitle;
  //
  //             // this.gVLogger.log(JSON.stringify(cart));
  //             this.storage.set("orderInStorage", this.order);
  //             if(Constants.isWebstore){
  //               this.nav.push(BulkShipmentPage,{"cart":cart,"TotalPrice":this.order.totalAmount, "orderView" : orderView})
  //             }else{
  //               this.nav.push(BulkShipmentPage,{"cart":cart,"TotalPrice":this.order.totalAmount, "orderView" : orderView});
  //
  //             }
  //           }
  //         },
  //         {
  //           text: 'Replace with new cart',
  //           handler: () => {
  //             this.shipmentCartManager.clearCart();
  //
  //           }
  //         }
  //       ]
  //     });
  //     confirm.present();
  //   }
  //   else {
  //     this.shipmentCartManager.clearCart();
  //   }
  //
  // }

  confirmBulkShipment() {
    if (!this.shipmentsData.shipments || this.shipmentsData.shipments.length === 0) {
      // this.msgManager.toastMsg("Please add shipments before updating.");
      this.msgManager.toastMsg("Fetch at least one (or more) orders for shipment by providing the order Id ");
      return;
    }

    let confirm = this.alertCtrl.create({
      title: 'Confirm Bulk Shipment!',
      message: 'Do you agree? This will ship all the shipments in the list',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
          }
        },
        {
          text: 'Agree',
          handler: () => {
            this.isUpdatingShipments = true;
            this.pickPackParamsFormUpdate();
            let ids = [];
            for (let ship of this.shipmentsData.shipments) {
              ids.push(ship.shipmentNoticeByNoticesId.id);
            }

            this.api.post("shipmentNotice/bulkShipment/", ids).map(res => res.json()).subscribe((data) => {
              if (data.status == "200") {
                this.downloadCSVButtonStatus = true;
                setTimeout(() => {
                  this.isUpdatingShipments = false;
                  // this.msgManager.toastMsg("All shipments shipped successfully.");
                  this.msgManager.toastMsg("All shipments shipped successfully. You can download the shipment report in CSV format using the provided link in the top right corder.");
                }, 1000);
              } else {
                this.isUpdatingShipments = false;
                this.msgManager.toastMsg("Problem while shipment.");
              }
            }, error => {
              this.isUpdatingShipments = false;
              this.msgManager.toastMsg("Error occurred while processing shipments.");
            });
          }
        },
      ]
    });
    confirm.present();
  }

  resetCart() {

    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      // message: "Are you sure you want to reset the cart?",
      message: "Clearing the list will also remove the Bulk Ship CSV. Make sure that you download it before using this option. Are you sure you want to clear?",
      buttons: [
        {
          text: 'NO',
          handler: () => {
          }
        },
        {
          text: 'YES',
          handler: () => {
            pickPackParams.params = "";
            this.bulkShipmentCartManager.clearCart()
            // this.enteredShipmentNo = ""
            this.downloadCSVButtonStatus = true;
          }
        }
      ]
    });
    confirm.present();


    // console.log("dddddddddd" + this.shipmentsData)


    // console.log(this.shipmentsData)
  }

  getCSVFromCARTItems() {
    this.downloadCSVButtonStatus = false;
    // this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.EDI_Integrations_License_alias+"&consumptionCount=0").map(res => res.json())
    //   .subscribe(data => {
    //     if(data.status === 570 || data.status === 571 || data.status === 403){

    // this.presentPaySatusAlert("Failure", data.message);
    // this.downloadCSVButtonStatus = true;
    // this.presentThankYouAlert("Failure", data.message);
    // }
    // else if(data.status === 200 || data.status === 270){

    let shipment = 0
    if (this.shipmentsData.shipments.length > 0) {
      shipment = this.shipmentsData.shipments[0].shipmentNoticeByNoticesId.id;
    }
    // this.api.post("/shipmentNotice/readPickPackParams?orderId="+shipment+"&adpCustomerUUID="+this.cartManager.getADPCustomerUUID(), "").map(res => res.json()).subscribe(  data =>{
    if (pickPackParams.params !== "") {
      this.processWithPickPackParams(pickPackParams.params);
    }
    else {
      this.processEmptyPickPackParams();
    }
    this.downloadCSVButtonStatus = true;
    // });
    // }
    // });


  }


  // getCSVFromCARTItems(){
  //   this.downloadCSVButtonStatus = false;
  //   // this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.EDI_Integrations_License_alias+"&consumptionCount=0").map(res => res.json())
  //   //   .subscribe(data => {
  //   //     if(data.status === 570 || data.status === 571 || data.status === 403){
  //
  //         // this.presentPaySatusAlert("Failure", data.message);
  //         // this.downloadCSVButtonStatus = true;
  //         // this.presentThankYouAlert("Failure", data.message);
  //       // }
  //       // else if(data.status === 200 || data.status === 270){
  //       //   this.api.post("/order/readPickPackParams?orderId="+this.shipmentsData.shipments.orderId+"&adpCustomerUUID="+this.cartManager.getADPCustomerUUID(), "").map(res => res.json()).subscribe(  data =>{
  //       //     if(data.status === "200" && data.length != 0){
  //       //       this.processPickPackPrams(data);
  //       //     }
  //       //     else{
  //             this.processEmptyPickPackParams();
  //         //   }
  //           this.downloadCSVButtonStatus = true;
  //         // });
  //       // }
  //     // });
  //
  //
  // }


  decodeData(encodeData) {
    return this.deoded = atob(encodeData);
  }

  processPickPackPrams(data) {
    // if(data.status === "200" || data.status === "270"){
    if (data.data != "") {
      this.pickPackParamsVariables = JSON.parse(this.decodeData(data.data));
    }
    'use strict';

    let temp = [];
    let csvCustomFields = this.paramsFromServer.documents.find(item => item.name == "bulkShipmentCSV").documentParams[0].fields;

    let csvCustomFieldsObjects = this.paramsFromServer.params;
    let lineItems = this.shipmentsData.shipments;
    let strCart = JSON.stringify(this.shipmentsData);
    // let objCart = JSON.parse(strCart);
    // let objADPCust = this.salesPerson;
    // let objOrder = [];
    // let shiptoAddress = this.shipto;
    // let TotalBeforeTax = this.TotalPriceBeforeTax;
    let index = 1;
    // let totalLength = this.lengthTotalizer.toFixed(4);

    for (let item of lineItems) {
      let obj = {};
      for (let csvField of csvCustomFields) {
        let label = "";
        let value = "";
        let type = "";
        let cutomFieldObj = csvCustomFieldsObjects.find(item => item.paramId == csvField.paramId);

        type = cutomFieldObj.type;
        if (type === 'linked') {
          try {
            let itemLocal = item;
            let strExpr = cutomFieldObj.value;
            value = eval(strExpr.trim());
          }
          catch (error) {
            this.gVLogger.log(error);
          }
        }
        else if (type === 'Empty') {
          try {
            let value1 = this.pickPackParamsVariables.find(item => item.paramId == csvField.paramId).value;
            if (value1 != "" || value1 != undefined) {
              value = value1;
            }
            else {
              value = "";
            }
          }
          catch (error) {
            // alert("value " + value)        ;
            // this.gVLogger.log(error);
          }
        }
        else {
          value = cutomFieldObj.value;
        }
        obj[cutomFieldObj.label + "~" + cutomFieldObj.paramId] = value;
      }
      temp.push(obj);
      index++;
    }
    // return this.cartManager.ConvertToCSVDynamically(temp);
    var blob = new Blob([this.cartManager.ConvertToCSVDynamically(temp)]);
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = "For 856 EDI.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

  }

  processEmptyPickPackParams() {
    this.gVLogger.log("else executed while read call give 404!" + JSON.stringify(this.shipmentsData));
    'use strict';

    let temp = [];
    let csvCustomFields = this.paramsFromServer.documents.find(item => item.name == "bulkShipmentCSV").documentParams[0].fields;

    console.log("CCCEEEEESSSSSSCVVVVVVVV " + JSON.stringify(csvCustomFields));
    //create an array of key value type based on the 'parameters' object the corresponding values of the linked formula
    let csvCustomFieldsObjects = this.paramsFromServer.params;
    let lineItems = this.shipmentsData.shipments;
    let index = 1;

    for (let item of lineItems) {
      let order = item.order;
      order.createdAt = new Date(order.createdAt)
      let obj = {};
      obj["Sr#"] = index;
      for (let csvField of csvCustomFields) {
        let objCart = { customer: { name: order.customerDTO.name } }
        let objADPCust = { adpCustomerInfo: this.cartManager.getAdpCustomerInfo() }
        // console.log("objADPCustobjADPCustobjADPCust " + JSON.stringify(objADPCust) )
        let dropsShipAddress = JSON.parse(order.customerDTO.locationsDTOs[0].dropshipLocation)
        let subTotal = 0
        let totalquantity = 0
        let customerOrderNumber = order.customerOrderNumber;
        if (customerOrderNumber === undefined || customerOrderNumber === null) {
          customerOrderNumber = "";
        }
        for (let detail of order.orderDetailDTOs) {
          let price = detail.price - detail.discount;
          price = price * detail.quantity;
          subTotal += price;
          totalquantity += detail.quantity;
        }
        // let salesPerson = this.cartManager.getSalesPerson();
        // objADPCust.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();
        // let objADPCust.adpCustomerInfo.companyName =

        let label = "";
        let value = "";
        let type = "";
        let cutomFieldObj = csvCustomFieldsObjects.find(item => item.paramId == csvField.paramId);

        console.log("obbbbbbbbbbbbbbbbbbbbbb " + JSON.stringify(cutomFieldObj))
        // console.log("obbbbbbbbbbbbbbbbbbbbbb " + JSON.stringify(cutomFieldObj) )

        type = cutomFieldObj.type;
        if (type === 'linked') {
          try {
            let itemLocal = item;
            let strExpr = cutomFieldObj.value;
            value = eval(strExpr);
          }
          catch (error) {
          }
        }
        else if (type === 'Empty') {
          try {
            let value1 = this.pickPackParamsVariables.find(item => item.paramId == csvField.paramId).value;
            if (value1 != "" || value1 != undefined) {
              value = value1;
            }
            else {
              value = "";
            }
          }
          catch (error) {
          }
        }
        else {
          value = cutomFieldObj.value;
        }
        obj[cutomFieldObj.label + "~" + cutomFieldObj.paramId] = this.stringifyGivenValue(value);
      }
      temp.push(obj);
      index++;
    }
    var blob = new Blob([this.cartManager.ConvertToCSVDynamically(temp)]);
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = "Bulk Shipment.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  processWithPickPackParams(data) {
    // this.gVLogger.log("else executed while read call give 404!" + JSON.stringify(this.shipmentsData));

    if (data != "") {
      this.pickPackParamsVariables = JSON.parse(this.decodeData(data));
    }
    'use strict';

    let temp = [];
    let csvCustomFields = this.paramsFromServer.documents.find(item => item.name == "bulkShipmentCSV").documentParams[0].fields;

    // console.log("CCCEEEEESSSSSSCVVVVVVVV "  + JSON.stringify(csvCustomFields));
    //create an array of key value type based on the 'parameters' object the corresponding values of the linked formula
    let csvCustomFieldsObjects = this.paramsFromServer.params;
    let lineItems = this.shipmentsData.shipments;
    let index = 1;

    for (let item of lineItems) {
      let order = item.order;
      order.createdAt = new Date(order.createdAt)
      let obj = {};
      obj["Sr#"] = index;
      for (let csvField of csvCustomFields) {
        let objCart = { customer: { name: order.customerDTO.name } }
        let objADPCust = { adpCustomerInfo: this.cartManager.getAdpCustomerInfo() }
        // console.log("objADPCustobjADPCustobjADPCust " + JSON.stringify(objADPCust) )
        let dropsShipAddress = JSON.parse(order.customerDTO.locationsDTOs[0].dropshipLocation)
        if (dropsShipAddress.contactPerson === undefined)
          dropsShipAddress.contactPerson = "";

        let subTotal = 0
        let totalquantity = 0
        let customerOrderNumber = order.customerOrderNumber;
        if (customerOrderNumber === undefined || customerOrderNumber === null) {
          customerOrderNumber = "";
        }
        for (let detail of order.orderDetailDTOs) {
          let price = detail.price - detail.discount;
          price = price * detail.quantity;
          subTotal += price;
          totalquantity += detail.quantity;
        }
        // let salesPerson = this.cartManager.getSalesPerson();
        // objADPCust.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();
        // let objADPCust.adpCustomerInfo.companyName =

        let label = "";
        let value = "";
        let type = "";
        let cutomFieldObj = csvCustomFieldsObjects.find(item => item.paramId == csvField.paramId);

        console.log("obbbbbbbbbbbbbbbbbbbbbb " + JSON.stringify(cutomFieldObj))
        // console.log("obbbbbbbbbbbbbbbbbbbbbb " + JSON.stringify(cutomFieldObj) )

        type = cutomFieldObj.type;
        if (type === 'linked') {
          try {
            let itemLocal = item;
            let strExpr = cutomFieldObj.value;
            value = eval(strExpr);
          }
          catch (error) {
          }
        }
        else if (type === 'Empty') {
          try {
            let value1 = this.pickPackParamsVariables.find(item => item.paramId == csvField.paramId).value;
            if (value1 != "" || value1 != undefined) {
              value = value1;
            }
            else {
              value = "";
            }
          }
          catch (error) {
          }
        }
        else {
          value = cutomFieldObj.value;
        }
        obj[cutomFieldObj.label + "~" + cutomFieldObj.paramId] = this.stringifyGivenValue(value)
      }
      temp.push(obj);
      index++;
    }
    var blob = new Blob([this.cartManager.ConvertToCSVDynamically(temp)]);
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = "Bulk Shipment.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  stringifyGivenValue(value) {
    if (value !== undefined && value !== null && value !== "") {
      return JSON.stringify(value)
    } else {
      return value
    }
  }

  pickPackParams() {
    let cart: any = {};

    // cart.orderId = this.enteredShipmentNo;
    cart.shipmentsIds = [];

    for (let ship of this.shipmentsData.shipments) {
      cart.shipmentsIds.push(ship.shipmentNoticeByNoticesId.id)
    }

    if (this.shipmentsData.shipments.length > 0) {
      cart.shipmentId = this.shipmentsData.shipments[0].shipmentNoticeByNoticesId.id;
      let modal = this.modalCtrl.create(PickPackParamsPage, { "cart": cart, "calledFrom": "bulkShipment" });
      modal.onDidDismiss(data => {
        // alert(pickPackParams.params)
      });
      modal.present();
    } else {
      let modal = this.modalCtrl.create(PickPackParamsPage, { "cart": cart, "calledFrom": "bulkShipment" });
      modal.onDidDismiss(data => {
        // alert(pickPackParams.params)
      });
      modal.present();
    }


  }

  pickPackParamsFormUpdate() {

    if (pickPackParams.params !== "") {
      for (let ship of this.shipmentsData.shipments) {
        this.api.post("/shipmentNotice/updatePickPackParams?PickPackParams=" + pickPackParams.params + "&orderId=" + ship.shipmentNoticeByNoticesId.id, "").subscribe(
          result => {
            if (result.status === 200) {
              // pickPackParams.params = "";
              this.gVLogger.log("Success message");
              this.msgManager.toastMsg("Updated successfully!");
              // this.pickPackParamsRead();

            } else {
              this.gVLogger.log("Some error");
              // this.pickPackParamsRead();
            }
          }, err => {
            this.gVLogger.log("error while Updating data : " + err);
          })
      }
    }


  }


  getParamsFieldsFromServer() {
    this.api.get("/adpCust/getIntelliStockParams")
      .map(res => res.json())
      .subscribe((results) => {
        if (results.status === "200") {
          let paramProvider = this.decode(results.data);
          this.paramsFromServer = JSON.parse(paramProvider);
          this.gVLogger.log("Prams from the server in confirm shipment page : " + this.paramsFromServer);
          setTimeout(() => {
            let paramsCustomFields = this.paramsFromServer.documents.find(item => item.name == "pickPackShip").documentParams.find(Item => Item.sectionLabel == "none").fields;
            if (paramsCustomFields.length > 0) {
              this.getParamsFieldsFromServerside = true;
            }
          }, 500)

        }
      });
  }

  decode(encodeData) {
    return atob(encodeData);
  }


  getCustomerName(shipment) {
    if (shipment.customerName !== undefined) {
      return shipment.customerName;
    } else {
      return ""
    }
  }

  getCustomerOrderNumber(shipment) {
    if (shipment.customerOrderNumber !== undefined) {
      return shipment?.order?.customerOrderNumber;
    } else {
      return ""
    }
  }


  onFocusBarcode(event) {
    event.target.value = "";
    this.barCodeFocus = "Scanner ACTIVE - Enter Order ID and press Enter to fetch the order for shipment";

  }
  onBlurBarcode(event) {
    event.target.value = "";

    this.barCodeFocus = "Scan Order ID or ERP/Scan Code here";
  }

  scrollBottom() {
    setTimeout(() => {
      this.content.scrollToBottom(200);
    }, 400)

  }

  ionViewDidLoad() {

    setTimeout(() => {
      this.barCodeFocusInput.setFocus();
    }, 500);
  }

}



// WEBPACK FOOTER //
// ./src/pages/bulk-shipment/bulk-shipment.ts